import { Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getRole, oraPrenotaStore } from "../oraPrenotaStore";
import { Loading } from "../ui/Loading";

export function LoginApi() {
  let { role, token } = useParams();
  const navigate = useNavigate();

  const setToken = oraPrenotaStore((state) => state.setToken);
  const setRole = oraPrenotaStore((state) => state.setRole);
  const roleEnum = role ? getRole(decodeURIComponent(role)) : undefined;

  useEffect(() => {
    if (roleEnum && token) {
      localStorage.clear();
      setToken(token);
      setRole(roleEnum);
      if (roleEnum === "USER") navigate("/app/tabelloneTariffe/prenota", { replace: true });
      else navigate("/app", { replace: true });
    }
  }, [roleEnum, token, navigate, setToken, setRole]);

  return (
    <>
      <Typography>Login in corso...</Typography>
      <Loading />
    </>
  );
}
